module.exports = __webpack_public_path__ + "static/media/paisagemudf-gfi.48c6851b.jpg";